import React, { useState } from "react";

// libarry and framework
import _ from "lodash";
import { Button, Spinner } from "react-bootstrap";
import { useMutation } from "@apollo/client";
import { useToasts } from "react-toast-notifications";

//component
import { CANCEL_JOINT_ORDER_GROUP } from "../../../graphql/orderGroup/mutation";
import ModalConfirmComponent from "../../ModalConfirmComponent";

// icons 
import { MdCancel } from "react-icons/md";

function BtnCancelJointOrderGroup({ setIsFetch, setIsSelectAll, setOrderGroupDownload, selectedIds, setSelectedIds}) {
    const { addToast } = useToasts();
    const [isConfirm, setIsConfirm] = useState(false)
    // TODO CALL API JOINT_ORDER 
    const [cancelJointOrderGroup, { loading: cancelJointOrderGroupLoading }] = useMutation(CANCEL_JOINT_ORDER_GROUP);

    const validateCancelJointOrderGroup = async ({ idIn }) => {
        try {
            if (cancelJointOrderGroupLoading) return;
            const _variables = {
                variables: {
                    where: {
                        idIn,
                    },
                },
            };
            // TODO: call api joint order
            const response = await cancelJointOrderGroup(_variables);
            if (_.isEmpty(response?.error)) {
                addToast("ຍົກເລີກລວມອໍເດີ ສຳເລັດ", {
                    appearance: "success",
                    autoDismiss: true,
                    timer: 3000,
                });
            setIsConfirm(false);
            setIsFetch(true);
            setIsSelectAll(false);
            setOrderGroupDownload([]);
            setSelectedIds([]);

            } else {
                addToast("ຍົກເລີກລວມອໍເດີ ຫລົ້ມເຫລວ!!", {
                    appearance: "error",
                    autoDismiss: true,
                    timer: 3000,
                });
            }
        } catch (error) {
            // console.log("joint order failed error: ", error);
            addToast("ຍົກເລີກລວມອໍເດີ ຫລົ້ມເຫລວ!", {
                appearance: "warning",
                autoDismiss: true,
            });
            setIsConfirm(false)
        }
    }

    return (
        <>

            <Button
                variant="light"

                disabled={
                   selectedIds && selectedIds.length > 0
                        ? false
                        : true
                }
                onClick={() => {
                    if (selectedIds.length <= 0) {
                        addToast("ກະລຸນາເລືອກອໍເດີ້ໃດຫນຶ່ງກ່ອນ!", {
                            appearance: "warning",
                            autoDismiss: true,
                        });
                        return;
                    };
                    setIsConfirm(true)
                }}
                style={{
                    display: 'flex', justifyContent: 'start', alignItems: 'center',width:'100%', color: 'red'
                }}
            >
                {
                    cancelJointOrderGroupLoading ? (<Spinner animation="border" size="sm" />
                    ) : (
                        <MdCancel style={{color: 'red'}}/>
                    )
                }
                &nbsp; ຍົກເລີກລວມອໍເດີທັງ
            </Button>

            <ModalConfirmComponent
                showConfirmModal={isConfirm}
                handleCancel={() => setIsConfirm(false)}
                handleConfirm={() => validateCancelJointOrderGroup({ idIn: selectedIds })}
                loadingConfirm={cancelJointOrderGroupLoading}
                title="🚨🚨🚨 ແຈ້ງເຕືອນ 🚨🚨🚨"
                text={`❌ ທ່ານແນ່ໃຈທີ່ຈະຍົກເລີກລວມອໍເດີທັງຫມົດບໍ❓ ❌
            ເພື່ອຄວາມແນ່ໃຈ ກະລຸນາກວດສອບອໍເດີຢ່າງລະອຽດ  ກ່ອນການຍົກເລີກລວມອໍເດີ
            ຖ້າທ່ານຕ້ອງການຍົກເລີກລວມອໍເດີທັງຫມົດ ກະລຸນາຄລິກ "ຢືນຢັນ". ຖ້າບໍ່ສາມາດຄລີກ "ຍົກເລີກ".`}
            />
        </>


    );
}

export default BtnCancelJointOrderGroup;
